import styles from './FeaturedCollections.module.scss';
import React from 'react';
import { clsx } from '../../../../utils/clsx';
export const FeaturedCollectionSkeleton = () => {
    return (React.createElement("div", { className: clsx('ov:h', styles.container) },
        React.createElement("ul", { className: clsx('list:none d:grid gaf:column', styles.items) }, [...Array(6)].map((v, i) => (React.createElement("li", { key: i },
            React.createElement("span", { className: "d:block skeleton bdrs:2 image-wrapper" }),
            React.createElement("span", { className: "d:block skeleton bdrs:2 fz:12 fz:16:lg-up mt:12 mt:16:lg-up mx:auto", style: { height: '1.59em', width: '70%' } })))))));
};
